module.exports = __webpack_public_path__ + "roboto-lightitalic-webfont.251542f6415f30642115.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-lightitalic-webfont.svg
// module id = ../../../../../src/assets/fonts/roboto-lightitalic-webfont.svg
// module chunks = styles